import Link from "next/link"
import { Play } from "lucide-react"
import styles from "./site-shell.module.css"

const FOOTER_GROUPS = [
  {
    title: "Play",
    links: [
      { href: "/play", label: "Play Higher Lower" },
      { href: "/monster-hunt", label: "Monster Hunt" },
      { href: "/daily", label: "Higher or Lower Daily" },
      { href: "/versus", label: "Higher or Lower Multiplayer" },
      { href: "/custom", label: "Custom Higher or Lower Games" },
    ],
  },
  {
    title: "Explore",
    links: [
      { href: "/which-is-more-popular", label: "Which Is More Popular" },
      { href: "/unblocked", label: "Higher or Lower Unblocked" },
      { href: "/how-to-play", label: "How to Play Higher or Lower" },
      { href: "/tiers", label: "Higher or Lower Tiers" },
      { href: "/guess-the", label: "Guess the Number" },
      { href: "/support", label: "Support" },
    ],
  },
  {
    title: "Free tools",
    links: [
      { href: "/tools", label: "All Tools" },
      { href: "/tools/would-you-rather", label: "Would You Rather Questions" },
      { href: "/tools/this-or-that", label: "This or That Questions" },
      { href: "/tools/random-trivia-generator", label: "Random Trivia Generator" },
    ],
  },
  {
    title: "About & policies",
    links: [
      { href: "/about", label: "About" },
      { href: "/data-methodology", label: "Data Sources & Methodology" },
      { href: "/community-guidelines", label: "Community Guidelines" },
      { href: "/privacy", label: "Privacy Policy" },
      { href: "/terms", label: "Terms of Service" },
      { href: "/support", label: "Contact & Support" },
    ],
  },
] as const

export function Footer() {
  return (
    <footer className={styles.footer} data-site-footer>
      <div className={styles.footerInner}>
        <div className={styles.footerIntro}>
          <Link href="/" className={styles.brand}>
            <span>Higher</span>
            <strong>Lower</strong>
          </Link>
          <p>
            Quick comparison games built from real-world data. Free to play,
            with no download required.
          </p>
          <Link href="/play" className={styles.footerCta}>
            Pick a game
            <Play aria-hidden="true" fill="currentColor" />
          </Link>
        </div>

        <div className={styles.footerDirectory}>
          {FOOTER_GROUPS.map((group) => (
            <section key={group.title}>
              <h2>{group.title}</h2>
              <nav aria-label={`${group.title} links`}>
                {group.links.map((link) => (
                  <Link href={link.href} key={`${group.title}-${link.href}`}>
                    {link.label}
                  </Link>
                ))}
              </nav>
            </section>
          ))}
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p>The Higher Lower Game</p>
        <p>Compare. Guess. Keep the streak alive.</p>
      </div>
    </footer>
  )
}
